import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { UserPrinter } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserPrinterService extends TmsWebBaseEditCreateService<UserPrinter, UserPrinter> {
  constructor() {
    super('UserPrinter', $localize`User Printer`);
  }
  getForUser(id: string): Observable<UserPrinter[]> {
    return this.httpService.get<UserPrinter[]>(`${this.apiUrl}/PrintersForUser?id=${id}`);
  }
}
